import type { RequestCopy } from "@/features/auth/components/auth-request-content";

/**
 * Copy for `/signup/resend_activation`.
 *
 * Every string is verbatim from the live reference
 * (xgodo.com/signup/resend_activation, legacy source
 * `frontend/src/app/(Account)/signup/resend_activation/page.tsx`). UX parity is
 * strict: this page says exactly these things and nothing else — no "back to
 * sign in" line under the form, no supporting illustration caption, no extra
 * reassurance copy.
 *
 * ONE deliberate departure: the live generic-failure string reads "Somting went
 * Wrong please try later!". That is a typo, and the project already fixes legacy
 * typos rather than reproducing them (see `nav.ts`, where the legacy "Availabel
 * Jobs" label is corrected). Flagged for the client either way.
 *
 * The state machine, the `?scenario=` parser and the shared visual primitives
 * live in `auth-request-*`, alongside `/forgot` — the two pages are the same
 * page on the live site with different words.
 */
export const RESEND_COPY: RequestCopy = {
  title: "Account Authentication Email",
  message:
    "If you haven’t received your authentication email after a few minutes of registering an account, enter your email address below and we’ll send it to you again. The email from us may arrive in your Bulk or Junk folder.",
  placeholder: "Enter your email",
  submit: "Send activation",
  success: "Activation email has been sent to your email address!",
  notFound: "Sorry, we could not find your email address in our system!",
  failed: "Something went wrong, please try later!",
};
